import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import App from "./App";
import store from "./store";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

// Zaštita od Google Translate-a i sličnih ekstenzija koje menjaju DOM:
// prevodilac umota tekstualne čvorove u <font> tagove, pa React pri
// sledećem re-renderu pokuša da ukloni/premesti čvor koji više nije tamo
// gde ga je ostavio i sruši celu aplikaciju (prazan beli ekran).
// Vidi: https://github.com/facebook/react/issues/11538
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      console.error(
        "removeChild preskočen — čvor je premestio prevodilac stranice",
      );
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.error(
        "insertBefore preskočen — čvor je premestio prevodilac stranice",
      );
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
  // </React.StrictMode>
);

reportWebVitals();
